import { gsap } from 'gsap';
import { EventEmitter } from 'events';
import { lerp, getMousePos, calcWinsize, distance, getRandomFloat } from './utils';
// body color
const bodyColor = getComputedStyle(document.body).getPropertyValue('--color-bg');

// Calculate the viewport size
let winsize = calcWinsize();
window.addEventListener('resize', () => winsize = calcWinsize());

// Track the mouse position
let mousepos = {x: 0, y: 0};
window.addEventListener('mousemove', ev => mousepos = getMousePos(ev));

function getTranslateXY(element) {
    const style = window.getComputedStyle(element)
    const matrix = new DOMMatrixReadOnly(style.transform)
    return {
        translateX: matrix.m41,
        translateY: matrix.m42
    }
}

export default class ButtonCtrl extends EventEmitter {
    constructor(el) {
        super();
        this.DOM = {el: el};
        // amounts the button will translate/scale
        this.renderedStyles = {
            tx: {previous: 0, current: 0, amt: 0.1},
            ty: {previous: 0, current: 0, amt: 0.1},
            scale: {previous: 1, current: 1, amt: 0.2}
        };

        // button state (hover)
        this.state = {
            hover: false
        };
        // calculate size/position
        this.calculateSizePosition();
        // init events
        this.initEvents();
        // loop fn
        requestAnimationFrame(() => this.render());
    }
    calculateSizePosition() {
        // size/position
        this.rect = this.DOM.el.getBoundingClientRect();
        // the movement will take place when the distance from the mouse to the center of the button is lower than this value
        this.distanceToTrigger = 50;
    }
    initEvents() {
        this.onResize = () => this.calculateSizePosition();
        window.addEventListener('resize', this.onResize);
    }
    render() {
        // calculate the distance from the mouse to the center of the button
        var TOP = this.rect.top;
        var MOUSE_X = mousepos.x;
        if(this.DOM.el.className.includes("ancora")) {
            TOP += getTranslateXY($("#ancore")[0]).translateY;
        }

        const distanceMouseButton_top = distance(MOUSE_X, mousepos.y+locoScroll.scroll.instance.scroll.y, this.rect.left + this.rect.width/2, TOP);
        const distanceMouseButton_left = distance(MOUSE_X, mousepos.y+locoScroll.scroll.instance.scroll.y, this.rect.left, TOP + this.rect.height/2);
        const distanceMouseButton_right = distance(MOUSE_X, mousepos.y+locoScroll.scroll.instance.scroll.y, this.rect.right, TOP + this.rect.height/2);
        const distanceMouseButton_bottom = distance(MOUSE_X, mousepos.y+locoScroll.scroll.instance.scroll.y, this.rect.left + this.rect.width/2, TOP + this.rect.height);

        // new values for the translations and scale
        let x = 0;
        let y = 0;

        if ( distanceMouseButton_top < this.distanceToTrigger || distanceMouseButton_left < this.distanceToTrigger || distanceMouseButton_right < this.distanceToTrigger || distanceMouseButton_bottom < this.distanceToTrigger) {
            if ( !this.state.hover ) {
                this.enter();
            }
            x = (MOUSE_X - (this.rect.left + this.rect.width/2))*.08;
            y = (mousepos.y + locoScroll.scroll.instance.scroll.y - (TOP + this.rect.height/2))*.08;
        }
        else if ( this.state.hover ) {
            this.leave();
        }

        this.renderedStyles['tx'].current = x;
        this.renderedStyles['ty'].current = y;

        for (const key in this.renderedStyles ) {
            this.renderedStyles[key].previous = lerp(this.renderedStyles[key].previous, this.renderedStyles[key].current, this.renderedStyles[key].amt);
        }

        this.DOM.el.style.transform = `translate3d(${this.renderedStyles['tx'].previous}px, ${this.renderedStyles['ty'].previous}px, 0)`;
        requestAnimationFrame(() => this.render());
    }
    enter() {
        this.emit('enter');
        this.state.hover = true;
        this.DOM.el.classList.add('button--hover');
        //document.body.classList.add('active');
        this.renderedStyles['scale'].current = 1.3;
    }
    leave() {
        this.emit('leave');
        this.state.hover = false;
        this.DOM.el.classList.remove('button--hover');
        //document.body.classList.remove('active');
        this.renderedStyles['scale'].current = 1;
        gsap.killTweensOf(document.body);
    }
}
